import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faExclamationCircle,
  faTimesCircle,
} from '@fortawesome/pro-light-svg-icons'

import { Box, FormField, Text } from '@domain-group/suit-theme'

import type { UseOrderItemPayload } from '@hooks/useOrderItem'

interface OrderItemErrorsProps {
  orderItemPayload: UseOrderItemPayload,
}

const OrderItemErrors = (props: OrderItemErrorsProps) => {
  const {
    orderItemPayload: {
      errors,
    },
  } = props

  if (!errors.length){
    return null
  }

  return (
    <FormField direction="column" label="Warnings" style={{ marginTop: 16 }}>
      <Box flexDirection="column" padding="large" variant="whiteGrey">
        {errors.map((error, index) => {
          const { blocker, message, type } = error
          return (
            <Box fontSize="small" key={type} marginTop={index === 0 ? null : 'medium'}>
              <Text color={blocker ? 'red' : 'orange'}>
                <FontAwesomeIcon icon={blocker ? faTimesCircle : faExclamationCircle} />
              </Text>
              <Text color={blocker ? 'red' : 'orange'} marginLeft="small">{message}</Text>
            </Box>
          )
        })}
      </Box>
    </FormField>
  )
}

export default OrderItemErrors
